import React from 'react'
// import { Field } from 'formik';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import { useState } from 'react'

export default function PasswordInput(props) {
  const {
    // label,
    fieldname,
    error,
    // fullWidth,
    onChange,
    // autoFocus,
    placeholder,
    name
    // halfWidth,
    // maxLength,
    // required,
    // className,
  } = props
  const [show, setShow] = useState(false)

  const handleToggle = () => {
    // console.log("here");
    setShow(!show)
  }

  return (
    <React.Fragment>
      <div className="password-input">
        <input
          type={show ? 'text' : 'password'}
          onChange={e => onChange(e)}
          className={error ? 'text-input has-error' : 'text-input'}
          placeholder={placeholder}
          autoComplete="new-password"
          autoComplete="new-password"
          name={name}
        />
        {show ? (
          <AiOutlineEye
            size="24px"
            color="#000"
            className="show-hide-btn"
            onClick={() => handleToggle()}
          />
        ) : (
          <AiOutlineEyeInvisible
            size="24px"
            color="#000"
            className="show-hide-btn"
            onClick={() => handleToggle()}
          />
        )}
      </div>
    </React.Fragment>
  )
}
